module.exports = __webpack_public_path__ + "static/1-80c289668cd4e36c48f28a409d9b0268.jpg";